import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map, pluck, takeUntil } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import * as i1 from '@angular/common/http';
import * as i3 from '@angular/forms';
import { Validators, ControlContainer, FormGroupDirective, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as errorUtils from 'error-message-utility';
import * as RolesRouteMap from 'app-models';
import * as i1$1 from 'reference-library';
import * as i4 from '@angular/router';
import * as i5 from 'primeng/dropdown';
import * as i6 from '@angular/common';
import * as i7 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i8 from 'primeng/api';
import { PrimengLibraryModule } from 'primeng-library';

class TaskDetailsService {
    constructor(httpClient) {
        this.httpClient = httpClient;
        this.isAutoPopulateBeneficiaryList = new BehaviorSubject(false);
    }
    getPetitionList(visaType) {
        return this.httpClient.get(`/${visaType}/petitionTypes`).pipe(map(response => {
            return response['data'];
        }));
    }
    getPetitionerClientList(companyId, countryType = '') {
        let apiUrl = `/company/${companyId}/hierarchy`;
        if (countryType !== '') {
            apiUrl = `${apiUrl}?${countryType}=USA`;
        }
        return this.httpClient.get(apiUrl).pipe(pluck('data'), map((data) => {
            return data;
        }));
    }
    getBeneficiariesByCompanyId(companyId, payload) {
        return this.httpClient.get(`/petitioner/dashboard/beneficiaries/company/associated/${companyId}/list`).pipe(
        // pluck('data'),
        // map((benes: Array<any>) => {
        //   benes.forEach(item => {
        //     item.firstname = item.beneficiaryEmployeeFName ? item.beneficiaryEmployeeFName : '',
        //       item.lastname = item.beneficiaryEmployeeLName ? item.beneficiaryEmployeeLName : '',
        //       item.middlename = item.beneficiaryEmployeeMName ? item.beneficiaryEmployeeMName : '-',
        //       item.company = (item.companyName) ? item.companyName : ''
        //   });
        //   return benes;
        // })
        map((response) => {
            if (response.status === 200 && response.data) {
                return response.data;
            }
            else {
                return [];
            }
        }));
    }
    // getBeneficiariesByCompanyIdForCreateTask(companyId, payload) {
    //   return this.httpClient.get(`petitioner/dashboard/beneficiaries/company/associated/${companyId}/list`).pipe(
    //     pluck('data'),
    //     pluck('beneficiaryList'),
    //     map((benes: Array<any>) => {
    //       benes.forEach(item => {
    //         item.firstname = item.beneficiaryEmployeeFName ? item.beneficiaryEmployeeFName : '',
    //           item.lastname = item.beneficiaryEmployeeLName ? item.beneficiaryEmployeeLName : '',
    //           item.middlename = item.beneficiaryEmployeeMName ? item.beneficiaryEmployeeMName : '-',
    //           item.company = (item.companyName) ? item.companyName : ''
    //       });
    //       return benes;
    //     })
    //   )
    // }
    getSubTasksType(superTaskType) {
        return this.httpClient.get(`/${superTaskType}/taskTypes`).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
        }));
    }
    getClientsList(companyId, reqJson) {
        return this.httpClient.post(`/attorney/dashboard/petitioner/company/${companyId}`, reqJson).pipe(map((response) => {
            return response.status === 200 ? response.data : [];
        }));
    }
    getBeneficiariesListForAttorney(companyId, payload) {
        return this.httpClient.post('/petitioner/dashboard/beneficiaries/company/' + companyId, payload).pipe(map((response) => {
            if (response.status === 200) {
                return response.data;
            }
            else {
                return null;
            }
        }));
    }
}
TaskDetailsService.ɵfac = function TaskDetailsService_Factory(t) { return new (t || TaskDetailsService)(i0.ɵɵinject(i1.HttpClient)); };
TaskDetailsService.ɵprov = i0.ɵɵdefineInjectable({ token: TaskDetailsService, factory: TaskDetailsService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaskDetailsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function TaskDetailsComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_span_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_span_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_div_20_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_div_20_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2, " Petitioning Company ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 20);
    i0.ɵɵlistener("onChange", function TaskDetailsComponent_div_20_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r12); const ctx_r11 = i0.ɵɵnextContext(); return ctx_r11.fetchPetitionerBeneficiary(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TaskDetailsComponent_div_20_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r3.petitionerCompanyList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.newTaskForm.get("companyId").touched && (ctx_r3.newTaskForm.get("companyId").errors == null ? null : ctx_r3.newTaskForm.get("companyId").errors.required));
} }
function TaskDetailsComponent_div_21_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_div_21_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2, " Petitioning Company ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 20);
    i0.ɵɵlistener("onChange", function TaskDetailsComponent_div_21_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r15); const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.fetchPetitionerBeneficiary(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TaskDetailsComponent_div_21_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r4.petitionerCompanyList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.newTaskForm.get("companyId").touched && (ctx_r4.newTaskForm.get("companyId").errors == null ? null : ctx_r4.newTaskForm.get("companyId").errors.required));
} }
function TaskDetailsComponent_div_22_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r16.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_div_22_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "label", 19);
    i0.ɵɵtext(2, " Petitioning Company ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "p-dropdown", 21);
    i0.ɵɵlistener("onChange", function TaskDetailsComponent_div_22_Template_p_dropdown_onChange_3_listener() { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.fetchPetitionerBeneficiary(); });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, TaskDetailsComponent_div_22_span_4_Template, 2, 1, "span", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", ctx_r5.attorneyCompanyList);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.newTaskForm.get("companyId").touched && (ctx_r5.newTaskForm.get("companyId").errors == null ? null : ctx_r5.newTaskForm.get("companyId").errors.required));
} }
function TaskDetailsComponent_a_24_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵlistener("click", function TaskDetailsComponent_a_24_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r20); const ctx_r19 = i0.ɵɵnextContext(); return ctx_r19.viewcompany(); });
    i0.ɵɵelementStart(1, "mat-icon", 23);
    i0.ɵɵtext(2, "corporate_fare ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function TaskDetailsComponent_29_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 25);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((ctx_r21.selectedBeneficiary == null ? null : ctx_r21.selectedBeneficiary.beneficiaryEmployeeFName) + " " + (ctx_r21.selectedBeneficiary == null ? null : ctx_r21.selectedBeneficiary.beneficiaryEmployeeLName));
} }
function TaskDetailsComponent_29_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, TaskDetailsComponent_29_ng_template_0_Template, 3, 1, "ng-template", 24);
} }
function TaskDetailsComponent_span_30_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.getGlobalErrorMessages("REQUIRED"), " ");
} }
function TaskDetailsComponent_a_32_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 22);
    i0.ɵɵlistener("click", function TaskDetailsComponent_a_32_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.viewbeneficiaries(); });
    i0.ɵɵelementStart(1, "mat-icon", 26);
    i0.ɵɵtext(2, "person");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
class TaskDetailsComponent {
    constructor(referenceLibraryService, 
    // private fb: FormBuilder,
    apiService, fb, parentFor, router) {
        this.referenceLibraryService = referenceLibraryService;
        this.apiService = apiService;
        this.fb = fb;
        this.parentFor = parentFor;
        this.router = router;
        this.selectedBeneficiary = {};
        this.taskTypeList = [];
        this.visaTypeList = [];
        this.petitionTypeList = [];
        this.petitionerCompanyList = [];
        this.attorneyCompanyList = [];
        this.beneficiaryList = [];
        this.userType = '';
        this.beneficiaryParamPayload = {
            pageNumber: 1,
            recordsPerPage: 100,
            searchCriteria: 'beneficiary',
            searchText: '',
            sortBy: 'companyName',
            sortOrder: 'asc',
            status: ['ACTIVE']
        };
        this.observableSubscription$ = new Subject();
        this.taskTypeList = [];
        this.visaTypeList = [];
        this.petitionerCompanyList = [];
        this.attorneyCompanyList = [];
        this.userType = sessionStorage.getItem('userTypeRole');
        this.newTaskForm = this.fb.group({
            id: [null],
            taskType: ["", Validators.required],
            visaType: ["", Validators.required],
            petitionType: ["", Validators.required],
            companyId: ["", Validators.required],
            beneficiaryId: ["", Validators.required],
        });
    }
    ngOnInit() {
        this.primaryCompanyId = parseInt(sessionStorage.getItem('companyId'));
        this.userType = sessionStorage.getItem('userTypeRole');
        this.getTaskType();
        this.getVisaType();
        if (this.userType === 'Petitioner') {
            this.getCompanyDetails();
        }
        else if (this.userType === 'Attorney') {
            this.getAttorneyCompanyDetails();
        }
        this.form = this.parentFor.form;
        this.form.addControl('newTaskForm', this.newTaskForm);
        this.newTaskForm.controls['visaType'].valueChanges.subscribe((data) => {
            this.getPetitionType();
        });
    }
    getTaskType() {
        this.referenceLibraryService.getReferenceData('SUPTSKTYP').subscribe((response) => {
            this.taskTypeList = response;
        });
    }
    getVisaType() {
        this.referenceLibraryService.getReferenceData('VISATYP').pipe(takeUntil(this.observableSubscription$)).subscribe((response) => {
            this.visaTypeList = response;
        });
    }
    getSubTaskType() {
        this.newTaskForm.patchValue({
            taskTypeCode: null,
        });
        if (this.newTaskForm.get('taskType').value) {
            this.apiService.getSubTasksType(this.newTaskForm.get('taskType').value)
                .subscribe((response) => {
                if (this.userType === 'Petitioner' || ['TN1', 'TN2'].includes(this.newTaskForm.get('visaType').value)) {
                    response = response.filter(ele => ele.code !== 'RFE');
                }
                this.subTaskType = response;
                if (!this.form.get('customQuestions').get('isOutsideImagility').value) {
                    this.newTaskForm.patchValue({
                        taskTypeCode: 'PETITION'
                    });
                }
            });
        }
    }
    getPetitionType() {
        this.apiService.getPetitionList(this.newTaskForm.get('visaType').value).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.petitionTypeList = response;
        });
    }
    getCompanyDetails() {
        this.apiService.getPetitionerClientList(this.primaryCompanyId).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.petitionerCompanyList = response;
        });
    }
    getAttorneyCompanyDetails() {
        const reqJson = {
            searchText: '',
            searchCriteria: '',
            sortBy: '',
            sortOrder: '',
            pageNumber: 0,
            recordsPerPage: 0
        };
        this.apiService.getClientsList(this.primaryCompanyId, reqJson).pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            // console.log("attorney list",response)
            this.attorneyCompanyList = response.petetionerList;
        });
    }
    fetchPetitionerBeneficiary() {
        this.form.controls['newTaskForm'].patchValue({
            beneficiaryId: null
        });
        if (this.form.controls['newTaskForm'].get('companyId').value) {
            this.getBeneficiaryList(this.form.controls['newTaskForm'].get('companyId').value);
        }
    }
    getBeneficiaryList(companyId) {
        this.apiService.getBeneficiariesByCompanyId(companyId, this.beneficiaryParamPayload).subscribe((data) => {
            if (data) {
                this.beneficiaryList = data;
                this.apiService.isAutoPopulateBeneficiaryList.next(this.beneficiaryList);
                // console.log(this.newTaskForm.value, '##########');
            }
        });
    }
    viewbeneficiaries() {
        sessionStorage.setItem('listBeneficiaryId', `${this.newTaskForm.get('beneficiaryId').value}`);
        sessionStorage.setItem('bene-profile-viewMode', 'true');
        let url;
        if (this.userType === RolesRouteMap.PETITIONER) {
            url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/beneficiaries/profile`;
        }
        else if (this.userType === RolesRouteMap.ATTORNEY) {
            url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/attorney/beneficiary/profile`;
        }
        this.router.navigate([]).then(() => {
            window.open(url, '_blank');
        });
    }
    viewcompany() {
        sessionStorage.setItem('viewModeCompanyId', `${this.newTaskForm.get('companyId').value}`);
        sessionStorage.setItem('company-viewMode', 'true');
        let url;
        if (this.userType === RolesRouteMap.PETITIONER) {
            url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/companies/petitioner/company/details`;
        }
        else if (this.userType === RolesRouteMap.ATTORNEY) {
            url = `${RolesRouteMap.userRoleRouteMapping[this.userType]}/client-companies/petitioner/company/details`;
        }
        this.router.navigate([]).then(() => {
            window.open(url, '_blank');
        });
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    handleTaskTypeChange() {
        // console.log('test');
    }
    handleVisaTypeChange() {
        // console.log('test');
    }
    postTaskDetails() {
    }
}
TaskDetailsComponent.ɵfac = function TaskDetailsComponent_Factory(t) { return new (t || TaskDetailsComponent)(i0.ɵɵdirectiveInject(i1$1.ReferenceLibraryService), i0.ɵɵdirectiveInject(TaskDetailsService), i0.ɵɵdirectiveInject(i3.FormBuilder), i0.ɵɵdirectiveInject(i3.FormGroupDirective), i0.ɵɵdirectiveInject(i4.Router)); };
TaskDetailsComponent.ɵcmp = i0.ɵɵdefineComponent({ type: TaskDetailsComponent, selectors: [["task-details-library"]], features: [i0.ɵɵProvidersFeature([], [
            { provide: ControlContainer, useExisting: FormGroupDirective },
        ])], decls: 33, vars: 14, consts: [["formGroupName", "newTaskForm"], [1, "row", "col-md-11"], [1, "row", "col-md-12", "mb-3"], [1, "col-md-4", "processing-dropdown"], ["for", "tasktype", 1, "label-cls", "required"], ["name", "taskType", "inputId", "tasktype", "formControlName", "taskType", "placeholder", "Select Task Type", "optionLabel", "name", "optionValue", "code", 3, "options"], ["class", "invalid-message", 4, "ngIf"], ["for", "visaType", 1, "label-cls", "required"], ["inputId", "visaType", "name", "visaType", "formControlName", "visaType", "placeholder", "Select Visa Type", "optionLabel", "name", "optionValue", "code", 3, "options", "onChange"], ["for", "petitionType", 1, "label-cls", "required"], ["inputId", "petitionType", "name", "petitionType", "formControlName", "petitionType", "placeholder", "Select Petition Type", "optionLabel", "name", "optionValue", "code", 3, "options", "onChange"], ["class", "col-md-3 processing-dropdown", 4, "ngIf"], [1, "col-md-1", "mt-4", "pt-2", "view-btn-block"], [3, "click", 4, "ngIf"], [1, "col-md-3", "processing-dropdown"], ["for", "beneficiaryId", 1, "label-cls", "required"], ["inputId", "beneficiaryId", "name", "beneficiaryId", "formControlName", "beneficiaryId", "placeholder", "Select Beneficiary Name", "optionLabel", "beneficiaryEmployeeFName", "optionValue", "beneficiaryEmployeeId", 3, "options"], [4, "ngIf"], [1, "invalid-message"], ["for", "companyId", 1, "label-cls", "required"], ["inputId", "companyId", "name", "companyId", "formControlName", "companyId", "placeholder", "Select Petitioning Company", "optionLabel", "companyName", "optionValue", "id", 3, "options", "onChange"], ["inputId", "companyId", "name", "companyId", "formControlName", "companyId", "placeholder", "Select Petitioning Company", "optionLabel", "petitionerName", "optionValue", "petitionerId", 3, "options", "onChange"], [3, "click"], ["matTooltip", "View Company", 1, "material-icons"], ["pTemplate", "selectedItem"], [1, "country-item", "country-item-value"], ["matTooltip", "View Beneficiary", 1, "material-icons"]], template: function TaskDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "label", 4);
        i0.ɵɵtext(5, " Task Type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "p-dropdown", 5);
        i0.ɵɵtemplate(7, TaskDetailsComponent_span_7_Template, 2, 1, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 3);
        i0.ɵɵelementStart(9, "label", 7);
        i0.ɵɵtext(10, " Visa Type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "p-dropdown", 8);
        i0.ɵɵlistener("onChange", function TaskDetailsComponent_Template_p_dropdown_onChange_11_listener() { return ctx.getPetitionType(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(12, TaskDetailsComponent_span_12_Template, 2, 1, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 2);
        i0.ɵɵelementStart(14, "div", 3);
        i0.ɵɵelementStart(15, "label", 9);
        i0.ɵɵtext(16, " Petition Type ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "p-dropdown", 10);
        i0.ɵɵlistener("onChange", function TaskDetailsComponent_Template_p_dropdown_onChange_17_listener() { return ctx.getSubTaskType(); });
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(18, TaskDetailsComponent_span_18_Template, 2, 1, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(19, "div", 2);
        i0.ɵɵtemplate(20, TaskDetailsComponent_div_20_Template, 5, 2, "div", 11);
        i0.ɵɵtemplate(21, TaskDetailsComponent_div_21_Template, 5, 2, "div", 11);
        i0.ɵɵtemplate(22, TaskDetailsComponent_div_22_Template, 5, 2, "div", 11);
        i0.ɵɵelementStart(23, "div", 12);
        i0.ɵɵtemplate(24, TaskDetailsComponent_a_24_Template, 3, 0, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 14);
        i0.ɵɵelementStart(26, "label", 15);
        i0.ɵɵtext(27, " Beneficiary Name");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(28, "p-dropdown", 16);
        i0.ɵɵtemplate(29, TaskDetailsComponent_29_Template, 1, 0, undefined, 17);
        i0.ɵɵtemplate(30, TaskDetailsComponent_span_30_Template, 2, 1, "span", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(31, "div", 12);
        i0.ɵɵtemplate(32, TaskDetailsComponent_a_32_Template, 3, 0, "a", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("options", ctx.taskTypeList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("taskType").touched && (ctx.newTaskForm.get("taskType").errors == null ? null : ctx.newTaskForm.get("taskType").errors.required));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.visaTypeList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("visaType").touched && (ctx.newTaskForm.get("visaType").errors == null ? null : ctx.newTaskForm.get("visaType").errors.required));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("options", ctx.petitionTypeList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("petitionType").touched && (ctx.newTaskForm.get("petitionType").errors == null ? null : ctx.newTaskForm.get("petitionType").errors.required));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.userType === "Platform");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType === "Petitioner");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.userType === "Attorney");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("companyId").value);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.beneficiaryList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.selectedBeneficiary);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("beneficiaryId").touched && (ctx.newTaskForm.get("beneficiaryId").errors == null ? null : ctx.newTaskForm.get("beneficiaryId").errors.required));
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.newTaskForm.get("beneficiaryId").value);
    } }, directives: [i3.NgControlStatusGroup, i3.FormGroupName, i5.Dropdown, i3.NgControlStatus, i3.FormControlName, i6.NgIf, i7.MatIcon, i8.PrimeTemplate], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaskDetailsComponent, [{
        type: Component,
        args: [{
                selector: 'task-details-library',
                templateUrl: 'task-details.component.html',
                viewProviders: [
                    { provide: ControlContainer, useExisting: FormGroupDirective },
                ],
            }]
    }], function () { return [{ type: i1$1.ReferenceLibraryService }, { type: TaskDetailsService }, { type: i3.FormBuilder }, { type: i3.FormGroupDirective }, { type: i4.Router }]; }, null); })();

class TaskDetailsModule {
}
TaskDetailsModule.ɵfac = function TaskDetailsModule_Factory(t) { return new (t || TaskDetailsModule)(); };
TaskDetailsModule.ɵmod = i0.ɵɵdefineNgModule({ type: TaskDetailsModule });
TaskDetailsModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule,
            MatIconModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(TaskDetailsModule, { declarations: [TaskDetailsComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule], exports: [TaskDetailsComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TaskDetailsModule, [{
        type: NgModule,
        args: [{
                declarations: [TaskDetailsComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule,
                    MatIconModule
                ],
                exports: [TaskDetailsComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of task-details
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TaskDetailsComponent, TaskDetailsModule, TaskDetailsService };
//# sourceMappingURL=task-details.js.map
